var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 57 57",
    style: {
      whiteSpace: "pre"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n@keyframes a0_t { 0% { transform: translate(28.432089px,27.999589px) rotate(0deg) scale(0.9,0.9) translate(-24.718438px,-30.432129px); } 100% { transform: translate(28.432089px,27.999589px) rotate(13deg) scale(0.9,0.9) translate(-24.718438px,-30.432129px); } }\n@keyframes a1_t { 0% { transform: translate(24.718438px,48px) rotate(0deg); } 7.1428% { transform: translate(24.718438px,48px) rotate(0deg); } 92.8571% { transform: translate(24.718438px,48px) rotate(0deg); } 100% { transform: translate(24.718438px,48px) rotate(0deg); } }\n@keyframes a1_v { 0% { visibility: visible; animation-timing-function: steps(1); } 7.1429% { visibility: hidden; animation-timing-function: steps(1); } 14.2857% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2_t { 0% { transform: translate(24.718438px,48px); } 7.1428% { transform: translate(24.718438px,48px); } 14.2857% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 7.1429% { visibility: visible; animation-timing-function: steps(1); } 14.2857% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2_t { 0% { transform: translate(24.718438px,48px); } 14.2857% { transform: translate(24.718438px,48px); } 21.4285% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 14.2857% { visibility: visible; animation-timing-function: steps(1); } 21.4286% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-2_t { 0% { transform: translate(24.718438px,48px); } 21.4285% { transform: translate(24.718438px,48px); } 28.5714% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-2_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 21.4286% { visibility: visible; animation-timing-function: steps(1); } 28.5714% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-3_t { 0% { transform: translate(24.718438px,48px); } 28.5714% { transform: translate(24.718438px,48px); } 35.7142% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-3_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 28.5714% { visibility: visible; animation-timing-function: steps(1); } 35.7143% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-4_t { 0% { transform: translate(24.718438px,48px); } 35.7142% { transform: translate(24.718438px,48px); } 42.8571% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-4_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 35.7143% { visibility: visible; animation-timing-function: steps(1); } 42.8571% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-5_t { 0% { transform: translate(24.718438px,48px); } 42.8571% { transform: translate(24.718438px,48px); } 50% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-5_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 42.8571% { visibility: visible; animation-timing-function: steps(1); } 50% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-6_t { 0% { transform: translate(24.718438px,48px); } 50% { transform: translate(24.718438px,48px); } 57.1428% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-6_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 50% { visibility: visible; animation-timing-function: steps(1); } 57.1429% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-7_t { 0% { transform: translate(24.718438px,48px); } 57.1428% { transform: translate(24.718438px,48px); } 64.2857% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-7_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 57.1429% { visibility: visible; animation-timing-function: steps(1); } 64.2857% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-8_t { 0% { transform: translate(24.718438px,48px); } 64.2857% { transform: translate(24.718438px,48px); } 71.4285% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-8_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 64.2857% { visibility: visible; animation-timing-function: steps(1); } 71.4286% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-9_t { 0% { transform: translate(24.718438px,48px); } 71.4285% { transform: translate(24.718438px,48px); } 78.5714% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-9_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 71.4286% { visibility: visible; animation-timing-function: steps(1); } 78.5714% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-10_t { 0% { transform: translate(24.718438px,48px); } 78.5714% { transform: translate(24.718438px,48px); } 85.7142% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-10_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 78.5714% { visibility: visible; animation-timing-function: steps(1); } 85.7143% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-11_t { 0% { transform: translate(24.718438px,48px); } 85.7142% { transform: translate(24.718438px,48px); } 92.8571% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-11_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 85.7143% { visibility: visible; animation-timing-function: steps(1); } 92.8571% { visibility: hidden; animation-timing-function: steps(1); } 100% { visibility: hidden; animation-timing-function: steps(1); } }\n@keyframes a2-12_t { 0% { transform: translate(24.718438px,48px); } 92.8571% { transform: translate(24.718438px,48px); } 100% { transform: translate(24.718438px,48px); } }\n@keyframes a2-12_v { 0% { visibility: hidden; animation-timing-function: steps(1); } 92.8571% { visibility: visible; animation-timing-function: steps(1); } 100% { visibility: visible; animation-timing-function: steps(1); } }\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Number",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76469,37.7469C-2.11727,27.3088,0.620465,16.0289,7.86722,8.52025C14.6181,1.52533,24.8311,-1.48934,34.2901,0.705459C40.9338,2.24701,46.9205,6.19126,50.9337,11.935C50.8491,11.9317,50.7641,11.93,50.6787,11.93C47.1966,11.93,44.3739,14.7527,44.3739,18.2348C44.3739,21.7169,47.1966,24.5396,50.6787,24.5396C52.5713,24.5396,54.2692,23.7057,55.4249,22.3851C58.1628,35.6861,50.8763,49.359,37.7595,54.237C32.4178,56.2235,26.8549,56.4741,21.6899,55.2723C12.8457,53.2144,5.16802,46.898,1.76469,37.7469Z",
    fill: "currentColor",
    transform: "translate(27.9985,27.9996) translate(-27.9985,-27.9996)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86722,8.52025C0.620465,16.0289,-2.11727,27.3088,1.76469,37.7469C5.16802,46.898,12.8457,53.2144,21.6899,55.2723C26.8549,56.4741,32.4178,56.2235,37.7595,54.237C52.248,48.8489,59.6231,32.7301,54.2322,18.2348C50.8267,9.07784,43.1414,2.75925,34.2901,0.705459C24.8311,-1.48934,14.6181,1.52533,7.86722,8.52025ZM23.5797,47.0882L32.4003,8.88958C38.619,10.3342,43.9818,14.7612,46.3621,21.1616C50.1357,31.3083,44.9731,42.5915,34.8312,46.3632C31.0806,47.7579,27.1994,47.9304,23.5898,47.0905C23.5865,47.0897,23.5831,47.089,23.5797,47.0882Z",
    fill: "currentColor",
    display: "none",
    transform: "translate(27.9985,27.9996) translate(-27.9985,-27.9996)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.4321,27.9996) scale(0.9,0.9) translate(-24.7184,-30.4321)",
    style: {
      animation: "1.4s linear both a0_t"
    }
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "visible",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a1_t, 1.4s linear forwards a1_v"
    }
  }, "0"), /*#__PURE__*/React.createElement("text", {
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2_t, 1.4s linear forwards a2_v"
    }
  }, "1"), /*#__PURE__*/React.createElement("text", {
    id: "a2",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2_t, 1.4s linear forwards a2_v"
    }
  }, "2"), /*#__PURE__*/React.createElement("text", {
    id: "a2-2",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-2_t, 1.4s linear forwards a2-2_v"
    }
  }, "3"), /*#__PURE__*/React.createElement("text", {
    id: "a2-3",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-3_t, 1.4s linear forwards a2-3_v"
    }
  }, "4"), /*#__PURE__*/React.createElement("text", {
    id: "a2-4",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-4_t, 1.4s linear forwards a2-4_v"
    }
  }, "5"), /*#__PURE__*/React.createElement("text", {
    id: "a2-5",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-5_t, 1.4s linear forwards a2-5_v"
    }
  }, "6"), /*#__PURE__*/React.createElement("text", {
    id: "a2-6",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-6_t, 1.4s linear forwards a2-6_v"
    }
  }, "7"), /*#__PURE__*/React.createElement("text", {
    id: "a2-7",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-7_t, 1.4s linear forwards a2-7_v"
    }
  }, "8"), /*#__PURE__*/React.createElement("text", {
    id: "a2-8",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-8_t, 1.4s linear forwards a2-8_v"
    }
  }, "9"), /*#__PURE__*/React.createElement("text", {
    id: "a2-9",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-9_t, 1.4s linear forwards a2-9_v"
    }
  }, "10"), /*#__PURE__*/React.createElement("text", {
    id: "a2-10",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-10_t, 1.4s linear forwards a2-10_v"
    }
  }, "11"), /*#__PURE__*/React.createElement("text", {
    id: "a2-11",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-11_t, 1.4s linear forwards a2-11_v"
    }
  }, "12"), /*#__PURE__*/React.createElement("text", {
    id: "a2-12",
    fill: "#ffffff",
    fontSize: 48,
    fontFamily: "'Euclid Flex'",
    letterSpacing: "-0.07em",
    wordSpacing: "-0.094em",
    stroke: "none",
    direction: "ltr",
    fontWeight: 500,
    writingMode: "horizontal-tb",
    textAnchor: "middle",
    visibility: "hidden",
    transform: "translate(24.7184,48)",
    style: {
      lineHeight: 16,
      animation: "1.4s linear both a2-12_t, 1.4s linear forwards a2-12_v"
    }
  }, "13")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M-1.23413,2.60469C0.333712,2.60469,1.60469,1.33371,1.60469,-0.234129C1.60469,-1.80197,0.333712,-3.07295,-1.23413,-3.07295C-2.80197,-3.07295,-4.07295,-1.80197,-4.07295,-0.234129C-4.07295,1.33371,-2.80197,2.60469,-1.23413,2.60469Z",
    fillRule: "evenodd",
    transform: "translate(51.9128,18.4689)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAni);
export default __webpack_public_path__ + "static/media/logo_ani.5311a39ceb52149cd466e0b026f2541b.svg";
export { ForwardRef as ReactComponent };